import "../style.css";
import React, { useEffect, useContext, useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import { AudioContext } from '../components/utils/AudioContext';


export default function MapPanel({ id, route, title, subtitle, description, prev, next, txtbtn }) {
    const location = useLocation();
    const { playTransi, playBtn } = useContext(AudioContext);

    useEffect(() => {
        const panel = document.querySelector(`#${id}`);
        if (location.pathname === route) {
            setTimeout(() => {
                panel.style.transform = 'translate(0, 0%)';
            }, 1500);
        } else {
            panel.style.transform = 'translate(0, 150%)';
        }
    }, [location, route, id]);

    const handleClick = () => {
        playTransi(); 
    };

    const handleHover = () => {
        playBtn(); 
    };

    return (
        <div id={id} className="panel">
            <div className="panel_infos">
                <h1>{title}</h1>
                <div className="panel_description">
                    <h2>{subtitle}</h2>
                    <p>{description}</p>
                </div>
            </div>
            <div className="panel_btn">
                {prev && (
                    <Link to={prev} className="panel_prev bt_sound" onClick={handleClick} onMouseEnter={handleHover}>
                        <svg
                            width="11"
                            height="11"
                            viewBox="0 0 11 11"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M8.68907 1.68568L4.56454 5.50492L8.68907 9.32416C9.10364 9.70805 9.10364 10.3282 8.68907 10.7121C8.27449 11.096 7.60478 11.096 7.19021 10.7121L2.31093 6.19396C1.89636 5.81007 1.89636 5.18993 2.31093 4.80604L7.19021 0.287919C7.60478 -0.0959731 8.27449 -0.0959731 8.68907 0.287919C9.09301 0.671812 9.10364 1.30179 8.68907 1.68568Z" />
                        </svg>
                    </Link>
                )}
                {next && (
                    <Link to={next} className="panel_next bt_sound" onClick={handleClick} onMouseEnter={handleHover}>
                        {txtbtn}
                    </Link>
                )}
            </div>
        </div>
    );
}
